import axios from 'axios';
import { message } from 'antd';
import NProgress from 'nprogress';
import { ISLOGIN, PageEnum, TABLEPAI, ORGAN_TYPE } from '@/enums/pageEnum';
import { getRedirectUri } from '@/utils/toolt';
import { NavigateFunction } from 'react-router-dom';

const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE,
  timeout: 30000,
  withCredentials: true,
  validateStatus: () => true,
});

const removeLogin = () => {
  localStorage.removeItem(ISLOGIN);
  localStorage.removeItem(ORGAN_TYPE);
  message.error('System failure, please try again later.', 2);
  window.location.replace(`${PageEnum.BASE_LOGIN}?redirect=${getRedirectUri()}`);
};
const setupAxiosInterceptors = (navigate: NavigateFunction) => {
  http.interceptors.request.use(
    (config) => {
      return config;
    },
    () => {
      NProgress.done();
    },
  );

  http.interceptors.response.use(
    (response) => {
      NProgress.done();
      const { status, config, data } = response;
      if (status >= 200 && status < 300) {
        return response;
      }
      if (status === 401) {
        removeLogin();
      }
      if (config.url === TABLEPAI.LOGIN && status === 400) {
        message.error('Incorrect user name or password.', 2);
        return response;
      }
      if (status === 403) {
        navigate('/403');
      }
      if (status >= 400 && status < 500) {
        // throw new Error("Request rejected.");
      }
      return Promise.reject(data || 'System failure, please try again later.');
    },
    (error) => {
      NProgress.done();
      return Promise.reject(error);
    },
  );
};

export { setupAxiosInterceptors, http };
